export const api_link = process.env.VUE_APP_BASEURL;

// auth
export const SIGN_IN = "api/v1/login";
export const LOG_OUT_USER = "api/v1/logout";
export const MY_PROFILE = "/api/v1/profile";
export const RESET_PASSWORD_SENDOTP = "api/v1/reset-password-sendotp";
export const RESET_PASSWORD = "api/v1/reset-password";

// permissions
export const GET_PERMISSIONS = "api/v1/get-permissions";
export const CREATE_PERMISSION = "api/v1/create-permission";
export const UPDATE_PERMISSION = "api/v1/update-permission"

// Role
export const CREATE_ROLE = "api/v1/create-role";
export const ASSIGN_PERMISSIONS = "api/v1/assign-permissions";
export const GET_ROLES = "api/v1/get-roles";
export const UPDATE_ROLE = "api/v1/update-role"

// user 
export const CHANGE_PASSWORD = "api/v1/user/change/password";
export const USER_LIST = "api/v1/user/list";
export const USER_STORE = "api/v1/user/store";
export const USER_UPADTE = "api/v1/user/update";
export const USER_DEATILS = "api/v1/user/details/"
export const PROFILE_UPDATE = "api/v1/profile-update";
export const RESET_USER_PASSOWRD = "api/v1/user/change/password-admin";

// Product Category 
export const PRODUCT_CATEGORY_LIST = "api/v1/product/category/list";
export const PRODUCT_CATEGORY_CREATE = "api/v1/product/category/store";
export const PRODUCT_CATEGORY_UPDATE = "api/v1/product/category/update";

// DIVISION
export const DIVISION_LIST = "api/v1/division/list";
export const DIVISION_CREATE = "api/v1/division/store";
export const DIVISION_UPDATE = "api/v1/division/update";

// AREA
export const AREA_LIST = "api/v1/area/list";
export const AREA_CREATE = "api/v1/area/store";
export const AREA_UPDATE = "api/v1/area/update";
export const AREA_LIST_MULTIPLE = "api/v1/area/multiple-list"

// Order
export const ORDER_LIST = "api/v1/order/list";
export const ORDER_DETAILS = "api/v1/order/details/";
export const ORDER_STATUS_LIST = 'api/v1/order/status/list';

// HUB
export const HUB_LIST = "api/v1/hub/list"
export const HUB_CREATE = "api/v1/hub/store"
export const HUB_UPDATE = "api/v1/hub/update"

// iSMS
export const iSMS_LIST = "api/v1/sms_config/list"
export const iSMS_CREATE = "api/v1/sms_config/store"
export const iSMS_UPDATE = "api/v1/sms_config/update"

// ZONE
export const ZONE_LIST = "api/v1/zone/list"
export const ZONE_CREATE = "api/v1/zone/store"
export const ZONE_UPDATE = "api/v1/zone/update"

// Consigment
export const CONSIGNMENT_LIST = "api/v1/consignment/list"
export const CONSIGNMENT_CREATE = "api/v1/consignment/store"
export const CONSIGNMENT_UPDATE = "api/v1/consignment/update"
export const ALL_REASON = "api/v1/all-reasons";
export const RECONSIGMENT_CREATE = "api/v1/consignment/reconcile";
export const CONSIGNMENT_STATUS_UPDATE = "api/v1/consignment/status-update";
export const DELIVARY_SCHEDULE_LIST = "api/v1/delivery-schedule"

//Dashboard
export const DASHBOARD = "api/v1/dashboard"
export const SELES_REPORT_EXPORT  = "api/v1/report/sales-report-export";

// NOtification
export const NOTIFICATION_LIST = "/api/v1/notification/list";
export const NOTIFICATION_MAKE_READ = "/api/v1/notification/make-read";

// Report 
export const ORDER_LIST_EXPORT = "api/v1/report/order-export"
export const USER_LIST_EXPORT = "api/v1/report/user-list-export"

